import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle, faSignOutAlt, faBars } from '@fortawesome/free-solid-svg-icons'; // Import faBars
import { useAuth } from '../contexts/AuthContext';

const AdminNavbar = ({ currentPageTitle, firstName, toggleSidebar }) => { // Added toggleSidebar prop
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();
  const { logout } = useAuth();

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="flex items-center justify-between bg-gray-700 p-4 shadow-md text-text-white">
      {/* Mobile Sidebar Toggle Button */}
      <button
        onClick={toggleSidebar}
        className="text-white focus:outline-none lg:hidden mr-4" // Show only on mobile, hide on large screens
      >
        <FontAwesomeIcon icon={faBars} className="text-2xl" />
      </button>

      <div className="text-xl font-semibold">
        {currentPageTitle}
      </div>
      <div className="relative">
        <button
          onClick={toggleDropdown}
          className="flex items-center space-x-2 text-text-white hover:text-accent-red focus:outline-none"
        >
          <FontAwesomeIcon icon={faUserCircle} className="text-2xl" />
          <span className="font-medium hidden sm:inline">Welcome, {firstName || 'Admin'}!</span> {/* Hide on small screens */}
        </button>

        {isDropdownOpen && (
          <div className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-md shadow-lg py-1 z-20 border border-border-subtle">
            <button
              onClick={handleLogout}
              className="block w-full text-left px-4 py-2 text-sm text-text-white hover:bg-gray-700 hover:text-accent-red flex items-center space-x-2"
            >
              <FontAwesomeIcon icon={faSignOutAlt} />
              <span>Logout</span>
            </button>
          </div>
        )}
      </div>
    </header>
  );
};

export default AdminNavbar;